<template>
    <a href="#" title="Supprimer ce point" @click="showConfirmationModal()">
        <i class="fas fa-fw fa-trash-alt text-danger"></i>
    </a>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'DeletePendingPoint',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    methods: {
        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer ce point ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: false,
                    }
                )
                .then((value) => {
                    //
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        async deleteItem() {
            try {
                await axios.delete(`/pendingPoints/${this.point.id}`)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
